import { render } from "./ClientDetailPage.vue?vue&type=template&id=455c459e"
import script from "./ClientDetailPage.vue?vue&type=script&lang=js"
export * from "./ClientDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__